<template>
  <div class="grid grid-5  gap">
    <Card
      v-for="product in products"
      :key="product.id"
      :product="product"
      :top-category="topCategory"
    />
  </div>
</template>

<script>
import Card from '@/components/catalog/Card.vue'
export default {
  name: 'Deck',
  components: {
    Card
  },
  props: {
    products: {
      type: Object,
      default: () => {}
    },
    topCategory: {
      type: Object,
      default: () => {
        return {
          id: 1
        }
      }
    }
  }
}
</script>
